module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/plant-a-tree-03ee985def0ab34cb41ef90121adc645.jpg";